/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniswapV3SwapTester,
  UniswapV3SwapTesterInterface,
} from "../UniswapV3SwapTester";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_quoteToken",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountOut",
        type: "uint256",
      },
      {
        internalType: "contract ISwapper",
        name: "_swapper",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
    ],
    name: "swapForAsset",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "contract ISwapper",
        name: "_swapper",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
    ],
    name: "swapForQuote",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniswapV3SwapTesterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniswapV3SwapTesterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniswapV3SwapTester__factory extends ContractFactory {
  constructor(...args: UniswapV3SwapTesterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UniswapV3SwapTester";
  }

  deploy(
    _quoteToken: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniswapV3SwapTester> {
    return super.deploy(
      _quoteToken,
      overrides || {}
    ) as Promise<UniswapV3SwapTester>;
  }
  getDeployTransaction(
    _quoteToken: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_quoteToken, overrides || {});
  }
  attach(address: string): UniswapV3SwapTester {
    return super.attach(address) as UniswapV3SwapTester;
  }
  connect(signer: Signer): UniswapV3SwapTester__factory {
    return super.connect(signer) as UniswapV3SwapTester__factory;
  }
  static readonly contractName: "UniswapV3SwapTester";
  public readonly contractName: "UniswapV3SwapTester";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapV3SwapTesterInterface {
    return new utils.Interface(_abi) as UniswapV3SwapTesterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV3SwapTester {
    return new Contract(address, _abi, signerOrProvider) as UniswapV3SwapTester;
  }
}
